(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.stemmer_pl = factory());
}(this, (function () { 'use strict';

  class Rule {
    constructor (requiredLength, affixes, howManyToRemove) {
      this.requiredLength = requiredLength;
      this.affixes = affixes;
      this.howManyToRemove = howManyToRemove;
    }
  }

  function isLongerThan (word, length) {
    return word.length > length
  }

  function startsWithAny (word, prefixes) {
    return prefixes.some(prefix => word.startsWith(prefix))
  }

  function endsWithAny (word, suffixes) {
    return suffixes.some(suffix => word.endsWith(suffix))
  }

  function removePrefix (word, toSlice) {
    if (toSlice < 0) { return word }
    return word.slice(toSlice, word.length)
  }

  function removeSuffix (word, toSlice) {
    if (toSlice <= 0) { return word }
    if (toSlice > word.length) { return '' }
    return word.slice(word, -toSlice)
  }

  function isSatisfiedPrefix (rule, word) {
    return isLongerThan(word, rule.requiredLength) && startsWithAny(word, rule.affixes)
  }

  function isSatisfiedSuffix (rule, word) {
    return isLongerThan(word, rule.requiredLength) && endsWithAny(word, rule.affixes)
  }

  function getPrefixToRemoveLength (word, rules) {
    const winRule = rules.find(r => isSatisfiedPrefix(r, word));
    return winRule !== undefined ? winRule.howManyToRemove : 0
  }

  function getSuffixToRemoveLength (word, rules) {
    const winRule = rules.find(r => isSatisfiedSuffix(r, word));
    return winRule !== undefined ? winRule.howManyToRemove : 0
  }

  function applySuffixRules (rules, word) {
    const suffixLength = getSuffixToRemoveLength(word, rules);
    return removeSuffix(word, suffixLength)
  }

  function applyPrefixRules (rules, word) {
    const prefixLength = getPrefixToRemoveLength(word, rules);
    return removePrefix(word, prefixLength)
  }

  function getStem (word) {
    if (typeof word !== 'string' || word === '') {
      return ''
    }

    let stem = word.toLowerCase();
    stem = removeNounAffix(stem);
    stem = removeDiminutiveAffix(stem);
    stem = removeAdjectiveAffix(stem);
    stem = removeVerbAffix(stem);
    stem = removeAdverbAffix(stem);
    stem = removePluralFormAffix(stem);
    stem = removeGeneralAffix(stem);
    return stem
  }

  const removeNounAffix = (word) => {
    const rules = [
      new Rule(7, ['zacja', 'zacją', 'zacji'], 4),
      new Rule(6, ['acja', 'acji', 'acją', 'tach', 'anie', 'enie', 'eniu', 'aniu'], 4),
      new Rule(6, ['tyka'], 2),
      new Rule(5, ['ach', 'ami', 'nia', 'niu', 'cia', 'ciu'], 3),
      new Rule(5, ['cji', 'cja', 'cją'], 2),
      new Rule(5, ['ce', 'ta'], 2)
    ];

    return applySuffixRules(rules, word)
  };

  const removeDiminutiveAffix = (word) => {
    const rules = [
      new Rule(6, ['eczek', 'iczek', 'iszek', 'aszek', 'uszek'], 5),
      new Rule(6, ['enek', 'ejek', 'erek'], 2),
      new Rule(4, ['ek', 'ak'], 2)
    ];

    return applySuffixRules(rules, word)
  };

  const removeAdjectiveAffix = (word) => {
    const prefixRules = [
      new Rule(0, ['naj'], 3)
    ];

    const suffixRules = [
      new Rule(4, ['sze', 'szy'], 3), // szą?
      new Rule(4, ['szych'], 5),
      new Rule(6, ['czny'], 4),
      new Rule(5, ['owy', 'owa', 'owe', 'ych', 'ego'], 3),
      new Rule(5, ['ej'], 2),
      new Rule(5, ['nym'], 2)
    ];
    const stem = applyPrefixRules(prefixRules, word);
    return applySuffixRules(suffixRules, stem)
  };

  const removeVerbAffix = (word) => {
    const rules = [
      new Rule(5, ['bym'], 3),
      new Rule(5, ['esz', 'asz', 'cie', 'eść', 'aść', 'łem', 'amy', 'emy'], 3),
      new Rule(3, ['esz', 'asz', 'eść', 'aść'], 2),
      new Rule(3, ['eć', 'ać'], 2),
      new Rule(3, ['aj'], 1),
      new Rule(3, ['ać', 'em', 'am', 'ał', 'ił', 'ić', 'ąc'], 2),
      new Rule(4, ['eli'], 2)
    ];

    return applySuffixRules(rules, word)
  };

  const removeAdverbAffix = (word) => {
    const rules = [
      new Rule(4, ['nie', 'wie'], 2),
      new Rule(4, ['ane'], 2),
      new Rule(4, ['rze'], 2)
    ];

    return applySuffixRules(rules, word)
  };

  const removePluralFormAffix = (word) => {
    const rules = [
      new Rule(4, ['ów', 'om'], 2),
      new Rule(4, ['ami'], 3),
      new Rule(4, ['ści'], 2)
    ];

    return applySuffixRules(rules, word)
  };

  const removeGeneralAffix = (word) => {
    const rules = [
      new Rule(4, ['ia', 'ie'], 2),
      new Rule(3, ['u', 'e', 'ą', 'i', 'a', 'y', 'ę', 'ł'], 1)
    ];

    return applySuffixRules(rules, word)
  };

  return getStem;

})));
